<template>
  <div>
    <h4
      v-if="showExistingNotice"
      class="-mt-4 italic text-sm"
      v-text="`You've already been invited!`"
    />
    <div class="flex justify-center">
      <a
        :href="`/invitations/${invitationCode}/accept`"
        class="btn btn--sm btn--border mr-1"
        v-text="'Accept'"
      />
      &nbsp;
      <a
        :href="`/invitations/${invitationCode}/reject`"
        class="btn btn--sm btn--border btn--danger ml-1"
        v-text="'Reject'"
      />
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'AcceptRejectButtons',
  props: {
    showExistingNotice: {
      type: Boolean,
      required: false,
      default: false,
    },
    invitationCode: {
      type: String,
      required: true,
    },
  },
}
</script>
